export function hasCommunicationPreferencesQuery(): boolean {
  return typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('settings') === 'privacy';
}

export function consumeCommunicationPreferencesQuery(): void {
  if (!hasCommunicationPreferencesQuery()) return;
  const url = new URL(window.location.href);
  url.searchParams.delete('settings');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
